module.exports = __webpack_public_path__ + "static/developer-london-skills-night-desk-fd6355bab5b9d0db3085adb18bd4ede7.svg";